'use client';

import React from 'react';
import { STRATEGY_DOT_COLORS, MAX_VISIBLE_DOTS } from './constants';

interface StrategyDotsProps {
  count: number;
  'data-testid'?: string;
}

const StrategyDots: React.FC<StrategyDotsProps> = ({
  count,
  'data-testid': testId,
}) => {
  if (count <= 0) return null;

  return (
    <span className="flex items-center gap-1" data-testid={testId}>
      <span className="flex items-center gap-0.5">
        {Array.from({ length: Math.min(count, MAX_VISIBLE_DOTS) }).map(
          (_, i) => (
            <span
              key={i}
              className={`w-2 h-2 rounded-full ${STRATEGY_DOT_COLORS[i % STRATEGY_DOT_COLORS.length]}`}
            />
          )
        )}
      </span>
      {count} {count === 1 ? 'Strategy' : 'Strategies'}
    </span>
  );
};

export default StrategyDots;
